import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _appIdentify;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.ends-with.js";
import $ from 'zepto';
import searchObj from './searchToObj';
import throttle from '@/utils/throttle';
import env from 'drip';
import URL from 'drip/utils/url';
import Cookie from 'drip/utils/cookie';
import Drip from 'drip';
import Geo from 'drip/geo';
var ACTIVITY_TAG = env.activityTag;
var appIdentify = (_appIdentify = {
  1: 'dianping_nova',
  2: 'movie',
  3: 'dianping_movie_wx',
  5: 'movie',
  6: 'maoyan_wxwallet_i',
  7: 'maoyan_wxwallet_i',
  8: 'gewara',
  13: 'yanchu_qqwallet_i',
  17: 'unknown',
  20: 'maoyan_baiduapp',
  22: 'TJAPP',
  27: 'yanchu_qqwallet_i_jiaotong',
  29: 'maoyan_xhsapp',
  30: 'maoyan_xhsapp',
  28: 'yanchu_qqwallet_i_zhaoshang'
}, _defineProperty(_appIdentify, "29", 'maoyan_xhsapp'), _defineProperty(_appIdentify, "30", 'maoyan_xhsmovie'), _defineProperty(_appIdentify, 31, 'maoyan_douyin_yanchu'), _defineProperty(_appIdentify, 37, 'group_wxapp'), _defineProperty(_appIdentify, 38, 'maoyan_show_wbapp'), _defineProperty(_appIdentify, 40, 'maoyan_bilibili_yanchu'), _defineProperty(_appIdentify, 41, 'maoyan_harmoney_microapp'), _defineProperty(_appIdentify, 42, 'maoyan_quickapp'), _defineProperty(_appIdentify, 43, 'maoyan_show_ysp'), _appIdentify);
var cookieDomain = {
  maoyan: '.maoyan.com',
  dianping: '.dianping.com',
  dianpingTest: '.51ping.com',
  localhost: 'localhost'
};
var valLabArray = ['abtest',
// "AB策略ID"
'order_id',
// "nm=BO,BP特有参数，订单ID 入库到业务订单系统中的生成返回的ID；有些业务系统会返回加密订单ID，和原始订单ID，建议上传加密ID；有些业务系统返回关键字使用tradeNo来标识orderid   "
'cat_id',
// "前台品类ID  跟category_id相同语义。"
'poi_id',
// "当前页面的poiid 公司通用商家ID，MDC统一管理"
'deal_id',
// "当前页面的dealid ； SKU粒度的商品信息，跟外卖sku_id相同语义 到餐，到综都有使用。"
'movie_id',
// "当前页面的电影ID"
'goods_id',
// "酒店"
'maiton_id',
// "买单ID"
'coupon_id',
// "优惠券ID"
'region_id',
// "商圈ID"
'stid',
// "当前页面内容通用策略标识参数名称，stid（包括扩展部分）共含有约27个key"
'ctpoi',
// "当前页面内容POI相关策略标识参数名称"
'traceid',
// "点评平台请求跟踪ID"
'keyword',
// "当前内容搜索关键词"
'activityid',
// "活动ID"
'cinemaid',
// "电影院ID"
'sortid',
// "推荐排序ID"
'selectid',
// "筛选ID"
'query_id',
// "搜索ID"
'index',
// "模块位置信息"
'ad_id',
// "广告内容id"
'title',
// "内容标题"
'biz_id',
// "点评侧业务标记，点评专用"
'sku_id',
// "货品ID"
'type',
// 在线观影购买类型
'status',
// "权益状态（1:有权益、2:无权益）"
'u_profile',
// 是否新用户（1:新用户，2:老用户)
'org',
//用户id
'order_st', 'bu_id', 'category_id', 'topic_id', 'viewtime'];
var utmKeys = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'];
var isFirstOnLoad = true;
window.lxTagReport = function (cid, mcBid) {
  var lab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Analytics('tag', 'movie', _defineProperty({}, cid, Object.assign({
    bid: mcBid
  }, lab)));
};

// viewEvt: 页面是否上报曝光事件
var analytics = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pgId) {
    var uid,
      options,
      appName,
      viewEvt,
      mtHistoryObj,
      appIdentifier,
      cityId,
      gcityId,
      domain,
      _i,
      _Object$values,
      value,
      oldUtm,
      oldUtmCookie,
      urlSearch,
      utmUrlFromTag,
      urlFromTag,
      urlSearchKeys,
      arrayHashQuery,
      HashQueryString,
      urlHashQuery,
      utmUrlHashFromTag,
      urlHashFromTag,
      urlHashQueryKeys,
      utm,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          uid = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
          options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          appName = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'dianping_nova';
          viewEvt = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
          mtHistoryObj = _args.length > 5 ? _args[5] : undefined;
          options = Object.assign({}, {
            autoSendPv: true
          }, options);

          // 以上Analytics字符串为导出到window上的函数，该函数为全局函数可在页面JS代码初始化时调用

          // 设置应用名称，3.0版本(sdk_ver)开始 Web SDK 会自动检测以下客户端的内嵌页面。
          // 自动检测列表: 团购(group)、点评(dianping_nova)、猫眼(movie)客户端、猫眼专业版(moviepro)客户端
          // 如果你需要将你的客户端加入自动白名单中，请联系 wangqiang18 或 zhangwei30
          appIdentifier = env.constant && env.constant.appType ? appIdentify[+env.constant.appType] : '';
          if (!uid || uid && '' === uid) {
            uid = 0;
          }
          Analytics('set', 'appnm', appIdentifier || 'unknown');
          Analytics('config', 'appnm', appIdentifier || 'unknown');
          if (!Drip.UA.isNative) {
            cityId = Drip.constant.cityId; // 设置全局cityid
            Analytics('set', 'cityid', cityId);
          }
          gcityId = (Geo.getLocCitySync() || {}).cityId;
          Analytics('set', 'locate_city_id', gcityId);
          if (Drip.UA.IS_QQWALLET && !uid) {
            Drip.User.getUserIdByForQQWallet().then(function (userId) {
              if (userId) {
                Analytics('use', 'movie', {
                  uid: userId
                });
              }
            }).catch(function (err) {
              console.warn(err);
            });
          }

          //设置应用上报通道标识与uid
          Analytics('use', 'movie', {
            uid: uid
          });

          // 设置页面的 cid
          Analytics('config', 'cid', pgId);

          /* ******* 手动设置 utm 开始 ********  */

          // 第一次打开清空 utm的cookie
          if (isFirstOnLoad) {
            domain = '';
            for (_i = 0, _Object$values = Object.values(cookieDomain); _i < _Object$values.length; _i++) {
              value = _Object$values[_i];
              if (location.host.indexOf(value) !== -1) {
                domain = value;
              }
            }
            Cookie.set('_lx_utm', '', {
              path: '/',
              expires: '',
              domain: domain
            });
            isFirstOnLoad = false;
          }
          oldUtm = {};
          oldUtmCookie = Cookie.get('_lx_utm');
          if (oldUtmCookie) {
            oldUtm = URL.parseQuery(oldUtmCookie);
          }

          // url base中的的query
          urlSearch = URL.query2Object(); // 兼容 fromTag TODO bd全部切换后 可以去去掉
          utmUrlFromTag = {};
          urlFromTag = urlSearch[ACTIVITY_TAG.FROM_TAG];
          if (urlFromTag) utmUrlFromTag.utm_source = urlFromTag;
          urlSearchKeys = Object.keys(urlSearch);
          urlSearchKeys.forEach(function (key) {
            if (!utmKeys.includes(key)) {
              delete urlSearch[key];
            }
          });

          // url hash中的的query
          arrayHashQuery = [];
          if (location.hash) {
            arrayHashQuery = location.hash.split('?');
          }
          HashQueryString = arrayHashQuery.length === 2 ? arrayHashQuery[1] : '';
          urlHashQuery = URL.parseQuery(HashQueryString); // 兼容 fromTag TODO bd全部切换后 可以去去掉
          utmUrlHashFromTag = {};
          urlHashFromTag = urlHashQuery[ACTIVITY_TAG.FROM_TAG];
          if (urlHashFromTag) {
            utmUrlHashFromTag.utm_source = urlHashFromTag;
          }
          urlHashQueryKeys = Object.keys(urlHashQuery);
          urlHashQueryKeys.forEach(function (key) {
            if (!utmKeys.includes(key)) {
              delete urlHashQuery[key];
            }
          });
          utm = Object.assign({}, oldUtm, utmUrlFromTag, urlSearch, utmUrlHashFromTag, urlHashQuery);
          Analytics('set', 'utm', utm);
          /* ******* 手动设置 utm 结束 ********  */

          window.seedPvAction = function () {
            var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options.custom || {};
            if (_typeof(opt) !== 'object') throw new Error('Arguments must be an Object');

            // 发送pv，其中"page_cid"为页面名称，你应该为你的每一个页面起一个唯一的名称
            // 如果调用此行代码前设置过 cid ( Analytics('config', 'cid', 'page_cid') ) 可以不设置 page_cid
            // 请确保在 use 方法之后调用 send 方法
            var custom = Object.assign(opt, {
              fromTag: searchObj && searchObj.fromTag ? searchObj.fromTag : 0 // 这里设置自定义埋点信息
            });

            if (mtHistoryObj) {
              Analytics('send', 'pv', {
                act: 'pageview',
                cid: pgId,
                ref: document.referrer,
                val: Object.assign({
                  custom: custom
                }, mtHistoryObj)
              });
            } else {
              Analytics('send', 'pv', {
                act: 'pageview',
                cid: pgId,
                ref: document.referrer,
                val: {
                  custom: custom
                }
              });
            }
          };
          window.seedAction = function (data) {
            var opts = {
              //   nm:'mge',暂时先去掉没搞懂啥意思
              val_bid: data.bid,
              element_id: data.id || ''
            };
            options.global && (opts.val_lab = Object.assign(opts.val_lab || {}, options.global));
            try {
              // 根据bid 判断 type
              var eventType = getEventTypeByBid(data.bid);
              if (eventType === null) {
                // 此时该点位是老点位 没有 mv mc me的后缀,采用默认的逻辑判断，如果有 后缀data中不需要传 evt这个字段
                if (data.evt === 'view') {
                  eventType = "moduleView";
                } else {
                  eventType = 'moduleClick';
                }
              }
              // 将所有参数扁平化
              var flatObj = extractCustomFields(data);
              // 构建vallab 和 custom
              var valLab = convertToCustomVal(flatObj);
              if (data.needTag && eventType === 'moduleClick') {
                // 自动上报tag
                var cid = pgId;
                Analytics('tag', 'movie', _defineProperty({}, cid, Object.assign({
                  bid: data.bid
                }, flatObj)));
              }
              var cityInfo = Geo.getLocCitySync() || {};
              if (pgId === 'c_c21utqjf') {
                valLab.custom = Object.assign({}, valLab.custom, {
                  locate_city_id: cityInfo.cityId,
                  def: cityInfo.def,
                  locate_city_name: cityInfo.cityName
                });
              }
              Analytics(eventType, data.bid, valLab);
            } catch (e) {
              console.error(e);
            }
          };

          // 外界去重置utm的方法
          window.resetUTMAction = function (utm) {
            Analytics('set', 'utm', utm);
          };
          options.autoSendPv && seedPvAction();
          autoReportMC();
          window.removeEventListener('scroll', window.StatusReportData);
          if (viewEvt) {
            window.addEventListener('scroll', window.StatusReportData, false);
          }
        case 44:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function analytics(_x) {
    return _ref.apply(this, arguments);
  };
}();
// 这是一个自动上报mc点位的方法，需要把 参数都放在dom 的 data-seed属性上
// 如果当前的点击事件会触发跳转，不适用此方法，需要在自己的onclick 事件中手动调用 seedAction
function autoReportMC() {
  // 自动上报MC点位
  $('body').on('click', '[data-seed]', function (e) {
    var seed = $(this).data('seed');
    var obj = {};
    if (Object.prototype.toString.call(seed).slice(8, -1) === 'Object') {
      obj = seed;
    } else {
      try {
        obj = JSON.parse(seed);
      } catch (error) {
        var strTrim = function strTrim(str) {
          return str.replace(/\'|\"/g, '').trim();
        };
        seed.split(',').forEach(function (v) {
          var temp = v.split(':');
          obj[strTrim(temp[0])] = strTrim(temp[1]);
        });
      }
    }
    if (!obj.bid) return;
    seedAction(obj);
  });
}
function getEventTypeByBid(str) {
  if (str.endsWith('_mv')) {
    return 'moduleView';
  } else if (str.endsWith('_mc')) {
    return 'moduleClick';
  } else if (str.endsWith('_me')) {
    return 'moduleEdit';
  } else {
    return null; // 或者返回其他默认值
  }
}
// 根据valLabArray 划分 vallab参数和custom参数
function convertToCustomVal(value) {
  var mapValue = {};
  var customValue = {};
  Object.keys(value).forEach(function (v) {
    if (valLabArray.includes(v)) {
      customValue[v] = value[v];
    } else {
      mapValue[v] = value[v];
    }
  });
  customValue.custom = mapValue;
  return customValue;
}
// 兼容业务侧传入的数据结构，进行拍平处理
function extractCustomFields(obj) {
  var custom = obj.custom;
  var otherCustom = null;
  if (custom && custom.custom) {
    otherCustom = custom.custom;
  }
  var result = Object.assign({}, obj, custom, otherCustom); // 浅拷贝对象
  delete result.custom;
  return result;
}
// 这是一个自动上报mv点位的方法，在长列表中 只上报出现在视图内的子元素，如 为你推荐
// 在窗口滚动条滚动时触发
// 如果有局部滚动条列表也需要使用，请参照 首页日历，由页面主动监听滚动条滚动，调用该函数
export function viewStats(e) {
  var eles = document.querySelectorAll(e.target.id ? "#".concat(e.target.id, " .scroll-view-stats") : '.scroll-view-stats');
  eles = Array.prototype.slice.call(eles, 0);
  eles.forEach(function (ele) {
    try {
      var _ref2 = ele.dataset || {},
        _ref2$view_bid = _ref2.view_bid,
        view_bid = _ref2$view_bid === void 0 ? '' : _ref2$view_bid,
        custom = _ref2.custom,
        view_seed = _ref2.view_seed;
      var bidObj = {};
      try {
        view_seed = JSON.parse(view_seed);
        bidObj = Object.assign({}, view_seed);
      } catch (error) {
        view_seed = null;
      }
      if (!view_bid && view_seed && view_seed.viewBid) {
        view_bid = view_seed.viewBid;
      }
      if (!custom && view_seed && view_seed.custom) {
        custom = view_seed.custom;
      }
      if (!view_bid) return false;
      if (!isEleInView(ele)) return false;
      seedAction(Object.assign({}, bidObj, {
        evt: 'view',
        bid: view_bid,
        custom: custom || {}
      }));
    } catch (error) {}
  });
}
window.StatusReportData = throttle(viewStats, 600);

// 判断元素是否在视图区内
function isEleInView(ele) {
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
  var _ele$getBoundingClien = ele.getBoundingClientRect(),
    x = _ele$getBoundingClien.x,
    y = _ele$getBoundingClien.y,
    width = _ele$getBoundingClien.width,
    height = _ele$getBoundingClien.height;
  return x >= 0 && y >= 0 && x + width / 2 <= viewWidth && y + height / 2 <= viewHeight;
}
export default analytics;